import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessCompanies } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";
import { canListAddresses } from "@/helpers/permissions";
import { canManageCompanies } from "@/helpers/permissions";

import { companyRoutes } from "./routes";

export const companyRoute = [
  {
    path: companyRoutes.list,
    lazy: async () => {
      const { CompanyListPage } = await import("./pages/CompanyListPage");

      return {
        element: (
          <RequireAuth permission={canAccessCompanies}>
            <CompanyListPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: companyRoutes.new,
    lazy: async () => {
      const { CreateCompanyPage } = await import("./pages/CreateCompanyPage");

      return {
        element: (
          <RequireAuth permission={canManageCompanies}>
            <CreateCompanyPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: companyRoutes.edit,
    lazy: async () => {
      const { EditCompanyPage } = await import("./pages/EditCompanyPage");

      return {
        element: (
          <RequireAuth permission={canManageCompanies}>
            <EditCompanyPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: companyRoutes.bulkUpload,
    lazy: async () => {
      const { CompanyBulkUploadPage } = await import("./pages/CompanyBulkUploadPage");

      return {
        element: (
          <RequireAuth permission={(x) => canListAddresses(x) && canManageCompanies(x)}>
            <CompanyBulkUploadPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: "*",
    element: <ErrorPage status={404} />,
  },
] satisfies RouteObject[];
